import { IRoleEnum } from "@interfaces";
import { routePath } from "@routes/path";

import type { ISidebarItems } from "@layout/sidebar/types";

export const sidebarOtherItems: ISidebarItems[] = [
  {
    iconName: "Settings2Line",
    name: "common.settings",
    items: { path: routePath.settings.home() },
  },
  {
    iconName: "Notification3Line",
    name: "common.notifications",
    items: { path: routePath.notifications.base() },
  },
  {
    iconName: "HeadphoneLine",
    name: "common.support",
    items: { path: routePath.support.home() },
  },
];

export const sidebarRoleItems: Record<IRoleEnum, ISidebarItems[]> = {
  [IRoleEnum.SUPER_ADMIN]: [
    {
      name: "superAdmin.dashboard.name",
      iconName: "Home3Line",
      items: { path: routePath.dashboard.home() },
    },
    {
      name: "superAdmin.plansManagement.name",
      iconName: "StarLine",
      items: { path: routePath.plansManagement.list() },
    },
    {
      name: "superAdmin.storesManagement.name",
      iconName: "Store3Line",
      items: { path: routePath.storesManagement.list() },
    },
    {
      name: "superAdmin.financialManagement.name",
      iconName: "ReceiptLine",
      items: {
        path: routePath.subscription.list(),
        child: [
          {
            name: "superAdmin.financialManagement.payInstallments.name",
            iconName: "MoneyDollarCircleLine",
            path: routePath.subscription.list(),
          },
          {
            name: "superAdmin.financialManagement.incomes.name",
            iconName: "SafeLine",
            path: routePath.income.list(),
          },
          {
            name: "superAdmin.financialManagement.debts.name",
            iconName: "HandCoinLine",
            path: routePath.debt.list(),
          },
        ],
      },
    },
  ],
  [IRoleEnum.STORE]: [
    {
      name: "superAdmin.dashboard.name",
      iconName: "Home3Line",
      items: { path: routePath.dashboard.home() },
    },
    {
      name: "storeAdmin.basicInfo.name",
      iconName: "Information2Line",
      items: {
        path: routePath.employeeList.list(),
        child: [
          {
            name: "storeAdmin.basicInfo.employeesList.name",
            iconName: "UserSettingsLine",
            path: routePath.employeeList.list(),
          },
          {
            name: "storeAdmin.basicInfo.customersList.name",
            iconName: "TeamLine",
            path: routePath.customerList.list(),
          },
          {
            name: "storeAdmin.basicInfo.supplierList.name",
            iconName: "TruckLine",
            path: routePath.supplierList.list(),
          },
          {
            name: "storeAdmin.basicInfo.warehouseList.name",
            iconName: "Building2Line",
            path: routePath.warehouseList.list(),
          },
          {
            name: "storeAdmin.basicInfo.financialYearList.name",
            iconName: "Calendar2Line",
            path: routePath.financialYearList.list(),
          },
          {
            name: "storeAdmin.basicInfo.itemCategories.name",
            iconName: "Apps2Line",
            path: routePath.itemCategory.list(),
          },
          {
            name: "storeAdmin.basicInfo.measurementUnit.name",
            iconName: "PencilRuler2Line",
            path: routePath.measurementUnit.list(),
          },
        ],
      },
    },
    {
      name: "storeAdmin.itemSaleSystem.name",
      iconName: "BarcodeBoxLine",
      items: { path: routePath.addNewSalesInvoices.create() },
    },
    {
      name: "storeAdmin.salesManagement.name",
      iconName: "ShoppingCartLine",
      items: {
        path: routePath.salesInvoice.list(),

        child: [
          {
            name: "storeAdmin.salesManagement.salesInvoice.name",
            iconName: "ReceiptLine",
            path: routePath.salesInvoice.list(),
          },
          {
            name: "storeAdmin.salesManagement.returnsList.name",
            iconName: "TextWrap",
            path: routePath.returnsList.list(),
          },
        ],
      },
    },
    {
      name: "storeAdmin.purchaseManagement.name",
      iconName: "ShoppingBagLine",
      items: {
        path: routePath.purchaseInvoices.list(),

        child: [
          {
            name: "storeAdmin.purchaseManagement.purchaseInvoices.name",
            iconName: "ReceiptLine",
            path: routePath.purchaseInvoices.list(),
          },
          {
            name: "storeAdmin.purchaseManagement.returnsList.name",
            iconName: "TextWrap",
            path: routePath.purchaseReturnsList.list(),
          },
        ],
      },
    },
    {
      name: "storeAdmin.warehouseManagement.name",
      iconName: "Building2Line",
      items: {
        path: routePath.centralWarehouseInventory.list(),
        child: [
          {
            name: "storeAdmin.warehouseManagement.centralWarehouseInventory.name",
            iconName: "Box3Line",
            path: routePath.centralWarehouseInventory.list(),
          },
          {
            name: "storeAdmin.warehouseManagement.salesWarehouseInventory.name",
            iconName: "Box3Line",
            path: routePath.salesWarehouseInventory.list(),
          },
          {
            name: "storeAdmin.warehouseManagement.quantityInventoryOfWasteWarehouses.name",
            iconName: "DeleteBin2Line",
            path: routePath.quantityInventoryOfWasteWarehouse.list(),
          },
          {
            name: "storeAdmin.warehouseManagement.priceList.name",
            iconName: "PriceTag3Line",
            path: routePath.priceList.list(),
          },
          {
            name: "storeAdmin.warehouseManagement.warehouseCirculationReport.name",
            iconName: "FileChart2Line",
            path: routePath.warehouseCirculationReport.list(),
          },
        ],
      },
    },
    {
      name: "storeAdmin.costManagement.name",
      iconName: "MoneyDollarCircleLine",
      items: {
        path: routePath.storeCostManagement.list(),
        child: [
          {
            name: "storeAdmin.costManagement.storeCosts.name",
            iconName: "Store3Line",
            path: routePath.storeCostManagement.list(),
          },
          {
            name: "storeAdmin.costManagement.employeeCosts.name",
            iconName: "UserSettingsLine",
            path: routePath.employeeCostManagement.list(),
          },
        ],
      },
    },
    {
      name: "storeAdmin.reportManagement.name",
      iconName: "FileChartLine",
      items: {
        path: routePath.salesReport.list(),
        child: [
          {
            name: "storeAdmin.reportManagement.salesReport.name",
            iconName: "ShoppingCartLine",
            path: routePath.salesReport.list(),
          },
          {
            name: "storeAdmin.reportManagement.purchaseReport.name",
            iconName: "ShoppingBagLine",
            path: routePath.purchaseReport.list(),
          },
          {
            name: "storeAdmin.reportManagement.financialReport.name",
            iconName: "Safe2Line",
            path: routePath.financialReport.list(),
          },
          {
            name: "storeAdmin.reportManagement.warehouseCirculationReport.name",
            iconName: "FileChart2Line",
            path: routePath.warehouseCirculationReportManagement.list(),
          },
          {
            name: "storeAdmin.reportManagement.employeeActivityReport.name",
            iconName: "UserSettingsLine",
            path: routePath.employeeActivityReport.list(),
          },
          {
            name: "storeAdmin.reportManagement.bestSellingReport.name",
            iconName: "Box3Line",
            path: routePath.bestSellingItemsReport.list(),
          },
          {
            name: "storeAdmin.reportManagement.topCustomerReport.name",
            iconName: "TeamLine",
            path: routePath.topCustomerReport.list(),
          },
        ],
      },
    },
  ],
  [IRoleEnum.STORE_EMPLOYEE]: [
    {
      name: "superAdmin.dashboard.name",
      iconName: "Home3Line",
      items: { path: routePath.dashboard.home() },
    },
    {
      name: "storeAdmin.basicInfo.customersList.name",
      iconName: "TeamLine",
      items: { path: routePath.customerList.list() },
    },
    {
      name: "storeAdmin.itemSaleSystem.name",
      iconName: "BarcodeBoxLine",
      items: { path: routePath.addNewSalesInvoices.create() },
    },
    {
      name: "storeAdmin.salesManagement.name",
      iconName: "ShoppingCartLine",
      items: {
        path: routePath.salesInvoice.list(),

        child: [
          {
            name: "storeAdmin.salesManagement.salesInvoice.name",
            iconName: "ReceiptLine",
            path: routePath.salesInvoice.list(),
          },
          {
            name: "storeAdmin.salesManagement.returnsList.name",
            iconName: "TextWrap",
            path: routePath.returnsList.list(),
          },
        ],
      },
    },
    {
      name: "storeAdmin.reportManagement.salesReport.name",
      iconName: "FileChartLine",
      items: {
        path: routePath.generalSalesReport.list(),
        child: [
          {
            name: "seller.reportManagement.general.name",
            iconName: "ShoppingCartLine",
            path: routePath.generalSalesReport.list(),
          },
          {
            name: "seller.reportManagement.itemBased.name",
            iconName: "Box3Line",
            path: routePath.itemBasedSalesReport.list(),
          },
          {
            name: "seller.reportManagement.supplierBased.name",
            iconName: "TruckLine",
            path: routePath.supplierBasedSalesReport.list(),
          },
        ],
      },
    },
  ],
  [IRoleEnum.UNKNOWN]: [],
};
